export const startEndChar = '|';

export const getCode = (code: string) => {
  return code.replaceAll(startEndChar, '');
};
